import z from 'zod';

export const SubmitAnswerBodySchema = z.object({
  attemptId: z.number(),
  questionId: z.number(),
  answerIds: z.array(z.number()),
});

export type SubmitAnswerBody = z.infer<typeof SubmitAnswerBodySchema>;
